import { Box, Typography } from '@mui/material';
import React from 'react';
import { StyledPackageContainer } from './index.style';
import CharacterPreservationReminder from './CharacterPreservationReminder';

const PackageContainer = ({
  packageName,
  productType,
  packageDetail,
  renderDescription = () => null,
  renderButton,
  isMobile,
  isFreePackage,
  hasLockCharactersLastOrder,
  packageNameLastOrder,
  lockCharacters,
  lastOrderPackageExpiryDate,
  preservationExpiryDate,
}) => (
  <StyledPackageContainer isMobile={isMobile}>
    <Box className="package-container">
      <Box className="package-header-container">
        <Box className="package-name-container">
          <Typography className="product-type-text">{productType}</Typography>
          <Typography className="package-name-text">({packageName})</Typography>
        </Box>
        {renderDescription()}
      </Box>
      {!isMobile && renderButton()}
    </Box>
    {packageDetail}
    {isMobile && renderButton()}
    {hasLockCharactersLastOrder && isFreePackage && (
      <CharacterPreservationReminder
        packageNameLastOrder={packageNameLastOrder}
        lastOrderPackageExpiryDate={lastOrderPackageExpiryDate}
        preservationExpiryDate={preservationExpiryDate}
        lockCharacters={lockCharacters}
      />
    )}
  </StyledPackageContainer>
);

export default PackageContainer;
